import { useState } from "react";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import { Step1, Step2, Step3, Step4, Step5 } from "./components";
import IconButton from '@mui/material/IconButton';

const choices = [
  'Merchant Information',
  'Transaction Details',
  'Fees',
  'Additional Fields',
  'Summary'
]

const STYLES = {
  leftBox: {
    backgroundColor: 'primary.main',
    color: 'white',
    borderRadius: '6px',
    padding: 3,
    height: '100%'
  },
  rightBox: {
    padding: 3
  },
  stepsBtn: {
    my: 4,
    cursor: 'pointer'
  },
  stepsNo: {
    color: 'white',
    border: '1px solid white',
    height: '1.5rem',
    width: '1.5rem',
    fontSize: '1rem'
  }
}

const CreateSettlement = () => {
  const [choice, setChoice] = useState(1);

  return <>
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <Box sx={ STYLES.leftBox }>
          <Typography variant="h5"><b>Step {choice}</b></Typography>
          { choices.map((item, index) => {
              return <Box key={index} onClick={() => setChoice(index + 1)} sx={ STYLES.stepsBtn }>
                <Grid container spacing={2}>
                  <Grid item>
                    <IconButton sx={ STYLES.stepsNo }>{index + 1}</IconButton>
                  </Grid>
                  <Grid item>
                    {item}
                  </Grid>
                </Grid>
              </Box>
            })
          }
        </Box>
      </Grid>
      <Grid item xs={9}>
        <Box sx={ STYLES.rightBox }>
        {
          choice === 1 ? <Step1 />
          : choice === 2 ? <Step2 />
          : choice === 3 ? <Step3 />
          : choice === 4 ? <Step4 />
          : <Step5 />
        }
        </Box>
      </Grid>
    </Grid>
  </>
}

export default CreateSettlement;